import {
  DecodedValueMap,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { DEFAULT_METRIC_APP } from 'pages/PerformanceMetrics/apps'
import { DashboardParamsState } from './sharedQueryParams'

export const performanceQueryParams = {
  app: withDefault(StringParam, DEFAULT_METRIC_APP),
}

export type PerformanceQueryParams = typeof performanceQueryParams

export type PerformanceQueryParamValues =
  DecodedValueMap<PerformanceQueryParams>

export const usePerformanceParams =
  (): DashboardParamsState<PerformanceQueryParams> => {
    const [query, setQuery] = useQueryParams(performanceQueryParams)

    return { query, setQuery }
  }
